module.exports = __webpack_public_path__ + "img/trofeu.7ecd6a93.png";